var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooleanicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E5FFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14V6H10.183C11.0259 6 11.6728 6.18156 12.1238 6.54468C12.5749 6.9078 12.8004 7.41844 12.8004 8.0766C12.8004 8.57589 12.6525 8.99196 12.3567 9.32482C12.0684 9.65768 11.6728 9.88085 11.1701 9.99433V9.82411C11.7468 9.8922 12.1941 10.0965 12.512 10.4369C12.8373 10.7773 13 11.2274 13 11.7872C13 12.4983 12.7671 13.0468 12.3013 13.4326C11.8355 13.8109 11.1774 14 10.3272 14H7ZM7.99815 13.1603H10.2274C10.7745 13.1603 11.2033 13.0544 11.5139 12.8426C11.8318 12.6232 11.9908 12.2638 11.9908 11.7645C11.9908 11.2577 11.8318 10.8983 11.5139 10.6865C11.2033 10.4747 10.7745 10.3688 10.2274 10.3688H7.99815V13.1603ZM7.99815 9.52908H10.0388C10.6229 9.52908 11.0591 9.4156 11.3475 9.18865C11.6359 8.95414 11.78 8.61749 11.78 8.17872C11.78 7.73995 11.6359 7.40709 11.3475 7.18014C11.0591 6.94563 10.6229 6.82837 10.0388 6.82837H7.99815V9.52908Z",
    fill: "#00B796"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooleanicon);
export default __webpack_public_path__ + "static/media/booleanicon.aded7b85.svg";
export { ForwardRef as ReactComponent };